export const ARTICLES_DEMARRER = [
  {
    path: "/demarrer/sinscrire-pas-a-pas",
    category: "Comment ça fonctionne",
    title: "S'inscrire sur un site de paris sportifs : les étapes",
    description:
      "Étapes d'inscription, justificatifs, délais de validation du compte (KYC) : tout savoir avant de créer un compte chez un opérateur agréé.",
    h1: "S'inscrire chez un opérateur : le guide pas à pas",
    intro:
      "Avant de commencer : vérifiez que l'opérateur est agréé (liste ANJ), que vous avez 18 ans révolus et que vous disposez de vos pièces justificatives.",
    sections: [
      {
        id: "etape-1",
        h2: "Étape 1 : créer son compte",
        blocks: [
          {
            t: "p",
            html: "Formulaire : identité (nom, prénom, date et lieu de naissance), adresse, e-mail, pseudo, mot de passe.",
          },
          { t: "p", html: "<strong>Conseil</strong> : utiliser un mot de passe unique et solide." },
        ],
      },
      {
        id: "etape-2",
        h2: "Étape 2 : accepter les conditions",
        blocks: [
          {
            t: "p",
            html: "Lire les conditions générales, la politique de confidentialité et les règles des bonus.",
          },
        ],
      },
      {
        id: "etape-3",
        h2: "Étape 3 : fixer ses limites",
        blocks: [
          {
            t: "p",
            html: "Certains opérateurs proposent de définir des limites de dépôt dès l'inscription. <strong>Nous recommandons de le faire immédiatement.</strong>",
          },
        ],
      },
      {
        id: "etape-4",
        h2: "Étape 4 : vérifier son identité (KYC)",
        blocks: [
          { t: "p", html: "Justificatifs généralement demandés :" },
          {
            t: "list",
            items: [
              "une pièce d'identité en cours de validité,",
              "un justificatif de domicile récent,",
              "un RIB ou une preuve de moyen de paiement à votre nom.",
            ],
          },
          {
            t: "p",
            html: "Les délais varient de quelques minutes à plusieurs jours. <strong>Le compte doit être vérifié pour permettre les retraits.</strong>",
          },
        ],
      },
      {
        id: "etape-5",
        h2: "Étape 5 : effectuer un premier dépôt",
        blocks: [
          {
            t: "p",
            html: "Choisir un moyen de paiement (voir « Dépôts et retraits »).",
          },
        ],
      },
      {
        id: "etape-6",
        h2: "Étape 6 : activer (ou non) le bonus de bienvenue",
        blocks: [
          {
            t: "p",
            html: "Lire les conditions avant d'accepter (voir « Bonus de bienvenue »).",
          },
        ],
      },
      {
        id: "problemes-frequents",
        h2: "Problèmes fréquents",
        blocks: [
          {
            t: "list",
            items: [
              "Documents refusés (flous, expirés, nom différent) → refaire des photos nettes, en entier.",
              "Vérification longue → contacter le service client.",
              "Compte bloqué → contacter le service client, sans créer de second compte.",
            ],
          },
          {
            t: "callout",
            kind: "retain",
            html: "Ne jamais communiquer son mot de passe, ne jamais prêter son compte et n'utiliser que des documents à son propre nom.",
          },
        ],
      },
    ],
  },
  {
    path: "/demarrer/depots-et-retraits",
    category: "Comment ça fonctionne",
    title: "Dépôts et retraits sur un site de paris sportifs",
    description:
      "Moyens de paiement, délais, frais, conditions de retrait : comprendre les dépôts et retraits chez un opérateur de paris sportifs agréé.",
    h1: "Dépôts et retraits : ce qu'il faut savoir",
    sections: [
      {
        id: "moyens-de-paiement",
        h2: "Les moyens de paiement courants",
        blocks: [
          {
            t: "p",
            html: "Carte bancaire, virement bancaire, portefeuilles électroniques, cartes prépayées, selon les opérateurs. <strong>Le moyen de paiement doit être à votre nom.</strong>",
          },
        ],
      },
      {
        id: "le-depot",
        h2: "Le dépôt",
        blocks: [
          {
            t: "p",
            html: "Généralement immédiat. Vérifiez les éventuels montants minimum et maximum, et utilisez la fonction de limite de dépôt.",
          },
        ],
      },
      {
        id: "le-retrait",
        h2: "Le retrait",
        blocks: [
          {
            t: "list",
            items: [
              "Il nécessite un compte vérifié (identité et moyen de paiement).",
              "Il est généralement effectué vers le moyen de paiement utilisé pour le dépôt.",
              "Délais habituels : de quelques heures à quelques jours ouvrés selon la méthode.",
              "Attention : un retrait peut être refusé ou différé si un bonus est actif et que ses conditions ne sont pas remplies.",
            ],
          },
        ],
      },
      {
        id: "frais-et-plafonds",
        h2: "Les frais et les plafonds",
        blocks: [
          {
            t: "p",
            html: "Renseignez-vous sur les frais éventuels, les montants minimums de retrait et les plafonds.",
          },
        ],
      },
      {
        id: "bonnes-pratiques",
        h2: "Bonnes pratiques",
        blocks: [
          {
            t: "p",
            html: "Conserver les preuves de transaction, ne pas déposer d'argent qu'on ne peut pas se permettre de perdre, faire des retraits réguliers plutôt que de laisser des fonds sur le compte.",
          },
        ],
      },
    ],
  },
  {
    path: "/demarrer/bonus-de-bienvenue",
    category: "Comment ça fonctionne",
    title: "Bonus de bienvenue des paris sportifs : comment ça marche ?",
    description:
      "Freebet, remboursement, dépôt majoré : comprendre les bonus de bienvenue, leurs conditions (rollover, cote minimale) et leurs pièges.",
    h1: "Bonus de bienvenue : comment ça marche vraiment ?",
    intro:
      "Les opérateurs proposent aux nouveaux joueurs des offres de bienvenue. Elles sont attractives, mais toujours soumises à des conditions. Voici comment les décrypter.",
    sections: [
      {
        id: "types-de-bonus",
        h2: "Les principaux types de bonus",
        blocks: [
          {
            t: "ol",
            items: [
              "<strong>Le remboursement du premier pari</strong> : si le premier pari est perdant, l'opérateur rembourse la mise, souvent sous forme de freebet, dans la limite d'un plafond.",
              "<strong>Le freebet</strong> : un pari offert. Seul le gain net est reversé, pas la mise.",
              "<strong>Le bonus sur dépôt</strong> : l'opérateur majore le premier dépôt (ex. 100 % jusqu'à un plafond), avec un multiplicateur de mise à respecter.",
              "<strong>La cote boostée</strong> : cote temporairement augmentée sur un événement.",
            ],
          },
        ],
      },
      {
        id: "conditions",
        h2: "Les conditions à lire à chaque fois",
        blocks: [
          {
            t: "list",
            items: [
              "Dépôt minimal requis.",
              "Plafond du bonus.",
              "<strong>Multiplicateur de mise (rollover)</strong> : combien de fois miser avant de retirer.",
              "<strong>Cote minimale</strong> des paris comptant pour les conditions.",
              "Durée de validité : délai pour utiliser ou valider le bonus.",
              "Marchés exclus : certains paris ne comptent pas.",
              "Un bonus par personne (et par foyer, adresse ou moyen de paiement selon les opérateurs).",
            ],
          },
        ],
      },
      {
        id: "exemple-freebet",
        h2: "Exemple 1 : le freebet",
        blocks: [
          { t: "p", html: "Freebet de 10 €, utilisé sur un pari à la cote 3,00." },
          {
            t: "list",
            items: [
              "Si le pari gagne : gain = 10 × (3,00 − 1) = <strong>20 €</strong> (et non 30 €, car la mise offerte n'est pas restituée).",
              "Si le pari perd : rien à retirer.",
            ],
          },
        ],
      },
      {
        id: "exemple-rollover",
        h2: "Exemple 2 : le rollover",
        blocks: [
          {
            t: "p",
            html: "Bonus de 100 € avec multiplicateur ×3 : il faut miser <strong>300 €</strong> (paris à la cote minimale imposée) avant de pouvoir retirer les gains liés au bonus.",
          },
        ],
      },
      {
        id: "pieges",
        h2: "Les pièges classiques",
        blocks: [
          {
            t: "list",
            items: [
              "Croire que le bonus est un cadeau sans contrepartie.",
              "Ne pas lire la cote minimale.",
              "Dépasser le délai de validité.",
              "Miser davantage pour « débloquer » le bonus.",
              "Ouvrir plusieurs comptes pour multiplier les bonus (interdit).",
            ],
          },
        ],
      },
      {
        id: "simulateur-bonus",
        h2: "Simulateur de bonus",
        blocks: [
          {
            t: "p",
            html: "Saisissez les conditions d'un bonus hypothétique pour visualiser le montant total à miser avant retrait.",
          },
          { t: "tool", name: "bonus" },
          {
            t: "callout",
            kind: "retain",
            html: "Un bonus n'est intéressant que si vous en comprenez toutes les conditions. Il ne doit jamais vous pousser à miser plus que prévu.",
          },
          {
            t: "p",
            html: "<em>Note : les montants et conditions des offres évoluent fréquemment. Référez-vous toujours aux conditions officielles de l'opérateur au moment de l'inscription.</em>",
          },
        ],
      },
    ],
  },
];
